var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signin-header" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          {
            staticClass: "back_icon",
            on: {
              click: function ($event) {
                return _vm.$router.back()
              },
            },
          },
          [
            _c("div", { staticClass: "iconfont icon-icon-back" }),
            _c("div", { staticClass: "back_text" }, [_vm._v("返回")]),
          ]
        ),
      ]),
      _c("div", { staticClass: "headline" }, [
        _vm._v(" " + _vm._s(_vm.courseInfo.name || "") + " "),
      ]),
      _c("div", { staticClass: "course_info" }, [
        _c("div", { staticClass: "course_item" }, [
          _c("div", { staticClass: "item_left iconfont icon-xxkc" }),
          _c("div", { staticClass: "item_right" }, [
            _vm._v(
              "  " +
                _vm._s(
                  _vm.courseInfo.classNames &&
                    _vm.courseInfo.classNames.join("，")
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "item_details",
              on: {
                click: function ($event) {
                  _vm.DetailsDialog = true
                },
              },
            },
            [_vm._v("详情")]
          ),
        ]),
        _c("div", { staticClass: "course_item" }, [
          _c("div", { staticClass: "item_left iconfont icon-jiaoshi" }),
          _c("div", { staticClass: "item_right" }, [
            _vm._v(" " + _vm._s(_vm.courseInfo.speakerText || "")),
          ]),
        ]),
        _c("div", { staticClass: "course_item" }, [
          _c("div", { staticClass: "item_left iconfont icon-address" }),
          _c("div", { staticClass: "item_right" }, [
            _vm._v(" " + _vm._s(_vm.courseInfo.place || "")),
          ]),
        ]),
        _c("div", { staticClass: "course_item" }, [
          _c("div", { staticClass: "item_left iconfont icon-rili" }),
          _c("div", { staticClass: "item_right" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.dsf.date.format(
                    _vm.courseInfo.beginDateTime,
                    "mm月dd日 hh:ii"
                  )
                )
            ),
          ]),
        ]),
      ]),
      _c(
        "van-dialog",
        {
          attrs: {
            width: "85%",
            title: "点击任意处关闭",
            "close-on-click-overlay": "",
            "show-confirm-button": false,
          },
          model: {
            value: _vm.DetailsDialog,
            callback: function ($$v) {
              _vm.DetailsDialog = $$v
            },
            expression: "DetailsDialog",
          },
        },
        [
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  _vm.DetailsDialog = false
                },
              },
            },
            [
              _c("div", {
                staticClass: "closeIcon iconfont icon-icon_wrong",
                on: {
                  click: function ($event) {
                    _vm.DetailsDialog = false
                  },
                },
              }),
              _c("div", { staticClass: "dialog_headline" }, [
                _vm._v("班次情况"),
              ]),
              _c(
                "div",
                { staticClass: "class_info" },
                _vm._l(_vm.courseInfo.classNames, function (item, index) {
                  return _c("div", { key: index, staticClass: "detail_item" }, [
                    _vm._v(" " + _vm._s(item) + " "),
                  ])
                }),
                0
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }